import { withStyles } from '@material-ui/core';

import Container from './component';
import styles from './styles';

export default withStyles(styles)(Container);
